import { Button, Heading, Input, Stack } from '@sixfold/common-ui';
import React from 'react';
import { useNavigate } from 'react-router';

import { useIsAdmin } from '../../lib/authorization';

export type UsersFilterInput = {
  searchInput?: string;
};

export const UsersFilter: React.FC<{
  activeFilters: {
    searchInput?: string;
  };
  onFilterToggle: (filter: { name: keyof UsersFilterInput; value: string | undefined }) => void;
  onClearFilters: () => void;
}> = ({ activeFilters: { searchInput }, onFilterToggle, onClearFilters }) => {
  const isAdmin = useIsAdmin();
  const navigate = useNavigate();
  return (
    <Stack direction="row" alignItems="center">
      <Heading size="large">Users</Heading>
      {isAdmin && (
        <Button onClick={() => void navigate('/users/new')} kind="primary" size="medium">
          Add User
        </Button>
      )}
      <div style={{ width: 250 }}>
        <Input
          label="User search"
          labelPosition="hidden"
          name="searchInput"
          placeholder="User search..."
          value={searchInput !== undefined ? searchInput : ''}
          onChange={(event) => {
            onFilterToggle({ name: 'searchInput', value: event.value === '' ? undefined : event.value });
          }}
        />
      </div>
      {searchInput !== undefined && (
        <Button onClick={onClearFilters} size="small">
          Clear filters
        </Button>
      )}
    </Stack>
  );
};
